import api from '@/modules/eventStream/api'
import { LiveUpdateState } from '@/modules/eventStream/types'
import { SseMessage } from 'event-source-plus'

const parseData = <T>(message: SseMessage): T => {
  return JSON.parse(message.data) as T
}

const createStream = <T>(state: LiveUpdateState, path: string, updateFn: (update: T) => void) => {
  state.updateStream = api.getStream(path).listen({
    onMessage: (message) => {
      updateFn(parseData<T>(message))
    }
  })
}

const deleteStream = (state: LiveUpdateState) => {
  if (state.updateStream) {
    state.updateStream.abort()
    state.updateStream = undefined
  }
}

const deleteTimeout = (state: LiveUpdateState) => {
  if (state.streamTimeOut) {
    clearTimeout(state.streamTimeOut)
    state.streamTimeOut = undefined
  }
}

export default {
  openStream: <T>(
    state: LiveUpdateState,
    path: string,
    updateFn: (update: T) => void,
    reloadFn: () => void
  ): void => {
    deleteStream(state)
    createStream(state, path, updateFn)

    // handle browser tab visibility change
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        state.streamTimeOut = setTimeout(() => {
          state.updateStream?.abort()
        }, 120000)
      } else if (document.visibilityState === 'visible') {
        deleteTimeout(state)

        reloadFn()

        if (state.updateStream) {
          state.updateStream.reconnect()
        } else {
          createStream(state, path, updateFn)
        }
      }
    })
  },

  closeStream: (state: LiveUpdateState) => {
    deleteStream(state)
    deleteTimeout(state)
  }
}
